// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7ffd2d5e","644":"a61b69ef"}[chunkId] + ".chunk.js";
};